import { useCreateProjectIndication } from 'lib/hooks/project/useCreateProjectIndication';
import React from 'react';
import styled from 'styled-components';
import IndicationCard, { IIndicationCard } from './IndicationCard';
import { IMaterialData } from 'lib/types/clinic/projectTypes';

interface ProjectIndicationMaterialProps {
  indicationMaterialList: (IIndicationCard | undefined)[] | undefined;
  materialIdx: string;
  onMaterialChange: (index: string, data?: IMaterialData) => void;
}

const ProjectIndicationMaterial = ({
  indicationMaterialList,
  materialIdx,
  onMaterialChange,
}: ProjectIndicationMaterialProps) => {
  return (
    <StyledProjectIndicationMaterial>
      {indicationMaterialList?.map((material?: IIndicationCard) => {
        if (!material) return;

        return (
          <IndicationCard
            key={material.key}
            selectedKey={materialIdx}
            cardItem={material}
            onClick={onMaterialChange}
          />
        );
      })}
    </StyledProjectIndicationMaterial>
  );
};

const StyledProjectIndicationMaterial = styled.div`
  padding: 20px;
  display: flex;
  flex-wrap: wrap;
  overflow: auto;
`;

export default ProjectIndicationMaterial;
